import { StatusMappingPermissions } from "./status-mapping-management.orders.permissions";

export class StatusMappingManagementPermissions {
  static StatusMapping = StatusMappingPermissions?.Permissions;
}

export function getStatusMappingModuleName() {
  return 'WorkflowManagement';
}
